import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Box,
  Typography,
} from '@mui/material';
import {
  Warning as WarningIcon,
} from '@mui/icons-material';

interface UnsavedChangesModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function UnsavedChangesModal({
  open,
  onClose,
  onConfirm,
}: UnsavedChangesModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 16px 48px rgba(0,0,0,0.1)',
        },
      }}
    >
      <DialogTitle sx={{ 
        pb: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}>
        <Box display="flex" alignItems="center" gap={2}>
          <WarningIcon 
            color="warning" 
            sx={{ fontSize: 28 }}
          />
          <Typography variant="h6" fontWeight={600}>
            Ungespeicherte Änderungen
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>
        <DialogContentText sx={{ 
          fontSize: 16,
          color: 'text.primary',
          lineHeight: 1.6,
        }}>
          Sie haben ungespeicherte Änderungen in dieser Aufgabe. 
          Wenn Sie jetzt schließen, gehen alle Änderungen verloren.
        </DialogContentText>
        
        <Box 
          sx={{ 
            mt: 2, 
            p: 2, 
            backgroundColor: 'warning.main', 
            color: 'warning.contrastText',
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <WarningIcon sx={{ fontSize: 20 }} />
          <Typography variant="body2" fontWeight={500}>
            Möchten Sie trotzdem ohne Speichern schließen?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ 
        px: 3, 
        py: 2, 
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        gap: 1,
      }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 500,
            px: 3,
            color: 'text.secondary',
            borderColor: 'divider',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: 'action.hover',
            }
          }}
        >
          Abbrechen
        </Button>
        
        <Button 
          onClick={onConfirm}
          variant="contained"
          color="warning"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 500,
            px: 3,
            boxShadow: '0 4px 12px rgba(237, 108, 2, 0.3)',
            '&:hover': {
              boxShadow: '0 6px 16px rgba(237, 108, 2, 0.4)',
            }
          }}
        >
          Ohne Speichern schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
